import React from 'react';

import Layout from '@/modules/corporate/modules/course/components/Layout';

import MainContentContainer from '../MainContent';
import { BodyViewProps } from './types';

const BodyContainer: React.FC<BodyViewProps> = () => {
  return (
    <Layout showLeft={false}>
      <Layout.Main>
        <MainContentContainer />
      </Layout.Main>
    </Layout>
  );
};

export default React.memo(BodyContainer);
